import Cookie from 'js-cookie'

export function getCookieOnClient(name: string): string | undefined {
    return Cookie.get(name)
}
